module.exports = __webpack_public_path__ + "static/img/logo7.923febf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo7.png
// module id = IQSF
// module chunks = 1